import { CommonModule } from "@angular/common";
import { Component, ElementRef, HostListener, ViewChild } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { AuthService } from "../../auth/services/auth.service";
import { MatMenuModule } from "@angular/material/menu";
import { ButonUserProfileComponent } from "../buton-user-profile/buton-user-profile.component";

declare global {
  interface Window {
    _paq: any[];
  }
}

declare let gtag: Function;
declare let _paq: any[];

@Component({
  selector: "app-menu-user",
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
    MatMenuModule,
    ButonUserProfileComponent,
  ],
  templateUrl: "./menu-user.component.html",
  styleUrl: "./menu-user.component.scss",
})
export class MenuUserComponent {
  @ViewChild("dropdownMenu") dropdownMenu!: ElementRef;

  isScreenSmall!: boolean;
  menuVisible = false;
  searchVisible: boolean = false;
  isScrolled: boolean = false;

  @ViewChild("searchInputLarge", { static: false }) searchInputLarge!: ElementRef;
  @ViewChild("searchInputSmall", { static: false }) searchInputSmall!: ElementRef;

  errorMessage: string | null = null;
  isInputValid = false;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    public authService: AuthService
  ) {}

  ngOnInit(): void {
    this.onResize("");
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    if (window.innerWidth >= 1280) {
      this.menuVisible = true;
      this.searchVisible = false;
      this.errorMessage = null;
    }
    if (window.innerWidth <= 1279) {
      this.menuVisible = false;
      this.searchVisible = false;
      this.errorMessage = null;
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isScrolled = scrollTop > 40;
  }

  toggleMenu(): void {
    this.menuVisible = !this.menuVisible;
  }

  closeMenu() {
    if (window.innerWidth < 1280) { 
      this.menuVisible = false;
    }
  }

  toggleSearch() {
    this.errorMessage = null;
    const inputElement = this.searchInputLarge?.nativeElement || this.searchInputSmall?.nativeElement;
    if (this.searchVisible && inputElement && inputElement.value.trim() !== "") {
      this.handleGoJob(inputElement.value.trim());
      this.searchVisible = !this.searchVisible;
    } else {
      this.searchVisible = !this.searchVisible;
      if (!this.searchVisible && inputElement) {
        inputElement.value = "";
      }
    }
  }

  handleRedirectSearch(event: KeyboardEvent) {
    if (event.key === "Enter") {
      const inputElement = event.target as HTMLInputElement;
      const query = inputElement.value;
      if (query.trim()) {
        this.errorMessage = null;
        this.handleGoJob(query);
        inputElement.value = "";
      } else {
        this.errorMessage = "*Ingrese un empleo";
      }
    }
  }

  handleRedirectSearchMobile(query: string): void {
    if (this.isInputValid) {
      this.errorMessage = null;
      this.handleGoJob(query);
      this.closeMenu(); // Se cierra el menú al buscar
    } else {
      this.errorMessage = "*Ingrese un empleo";
    }
  }

  handleGoJob(query: string) {
    this._router.navigate(["empleo", `search=${query}`]);
    if (this.searchInputLarge) {
      this.searchInputLarge.nativeElement.value = "";
    }
    if (this.searchInputSmall) {
      this.searchInputSmall.nativeElement.value = "";
    }
  }

  validateInput(value: string): void {
    this.isInputValid = value.trim().length > 0;
  }

  trackMenuEvent(menuItem: string): void {
    gtag("event", "menu_click", {
      event_category: "Menu",
      event_label: menuItem,
    });
  }

  trackMenuClick(option: string): void {
    if (window._paq) {
      _paq.push(["trackEvent", "Menu", "Click", option]);
    }
  }
}
